import { styled } from '@mui/material/styles';

export const Content = styled('div')(() => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	height: '100%',
}));
